// Centralised test IDs used across the site
export const TEST_IDS = {
  nav: {
    logo: "nav-logo",
    home: "nav-home",
    about: "nav-about",
    services: "nav-services-toggle",
    caseStudies: "nav-case-studies",
    gallery: "nav-gallery",
    reviews: "nav-reviews",
    contact: "nav-contact",
    cta: "nav-cta",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    primaryCta: "hero-primary-cta",
    secondaryCta: "hero-secondary-cta",
  },
  contact: {
    form: "contact-form",
    name: "contact-name",
    email: "contact-email",
    phone: "contact-phone",
    address: "contact-address",
    issueType: "contact-issue-type",
    description: "contact-description",
    photos: "contact-photos",
    preferredContact: "contact-preferred",
    submit: "contact-submit",
    success: "contact-success",
    error: "contact-error",
  },
  footer: {
    container: "site-footer",
    phone: "footer-phone",
    email: "footer-email",
  },
};

// Keep legacy export for any leftover references
export const HOME = { emergentLink: "emergent-link" };
